import { render, staticRenderFns } from "./CustomerVendorForm.vue?vue&type=template&id=ae2d6e3a&"
import script from "./CustomerVendorForm.vue?vue&type=script&lang=js&"
export * from "./CustomerVendorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports